export const getFibonaciNumbers = count => {
  const array = [1];
  count >= 2 && array.push(1);

  for (let i = 3; i <= count; ++i) {
    array.push(array[i - 2] + array[i - 3]);
  }
  return array;
};
